// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__HCwB5","notes":"Notes_notes__1qZzq"};